module.exports = __webpack_public_path__ + "img/fn-2.3124e56.svg";